import Campus from './sub-components/Campus';
import DateTest from './sub-components/DateTest';
import Formation from './sub-components/Formation';
import { Col, Row } from 'reactstrap';
import TagManager from 'react-gtm-module';


const tagManagerArgs = {
    dataLayer: {
        'event': 'eni_JourneeInscription'
    },
    dataLayerName: 'PageDataLayer'
}

const Journee = ({ nextStep, handleChange, values, modalites, campus, filieres, typesFormations, handleErreur, CodeTypeJourneeInformation }) => {
    
    const dates = filieres?.find(f => (f.id == values.idFiliere && CodeTypeJourneeInformation == 0)/*Cas journée test classique*/ || (f.id === 3 && CodeTypeJourneeInformation == 1)/*Cas journée école*/)
        ?.formations?.find(f => (f.id == values.idFormation && CodeTypeJourneeInformation == 0)/*Cas journée test classique*/ || (f.id === 1400949 && CodeTypeJourneeInformation == 1)/*Cas journée école*/)
        ?.journeesTest;

    const getModalite = () => {
        return modalites.map((modalite) => {
            return <option key={modalite.id} value={modalite.id}>{modalite.libelle}
            </option>;
        });
    }
    const getTypeFormation = () => {
        return typesFormations
            .filter((typeFormation) => {
                return (
                    values.idModaliteSuivi == 121581 /*Présentiel*/ &&
                    values.idCampus == 16 && /*Nantes*/
                    values.idFormation == process.env.REACT_APP_ID_TECHNICIEN_HELPDESK/*formation Technicien HelpDesk*/ &&
                    typeFormation.id == 121134 /*Formation continue*/
                )
                    ||
                    (values.idFormation != process.env.REACT_APP_ID_TECHNICIEN_HELPDESK)
            })
            .map((typesFormation) => {
                return <option value={typesFormation.id}>{typesFormation.libelle}
                </option>;
            });
    }
    const getFiliere = () => {
        return filieres.map((filiere) => {
            if (filiere.libelle && filiere.id != 3) {
                var checked = filiere.id == values.idFiliere ? "checked" : "";
                return <div key={filiere.id} class="form-check-inline mr-10percent-custom d-flex"><input type="radio" checked={checked} name="filiere" id={'filiere' + filiere.id} value={filiere.id} onChange={handleChange('idFiliere')} />
                    <label class="openSans fs-16 color-blue-dark-eni lh-22" for={'filiere' + filiere.id}>{filiere.libelle}</label></div>;
            }
        });
    }
    const Continue = e => {
        e.preventDefault();
        nextStep();
    }

    TagManager.dataLayer(tagManagerArgs)

    return (
        <div>
            <h1 className="mb-5 color-green-eni spinnaker text-center fs-32">{CodeTypeJourneeInformation == 1 ? "Vous venez de suivre une présentation dans votre établissement et vous souhaitez passer les tests ? Inscrivez-vous dès maintenant."
                : "Sélectionnez votre souhait de formation"}</h1>
            <Row className="mb-5">
                <Col sm="6">
                    <div class="d-flex flex-column">
                        <label>Comment souhaitez-vous réaliser la formation ?*</label>
                        <select
                            type="text"
                            value={values.idModaliteSuivi}
                            onChange={handleChange('idModaliteSuivi')}
                            id="idModaliteSuivi"
                        >
                            <option value="0" selected="selected"></option>
                            {getModalite()}
                        </select>
                        {handleErreur('idModaliteSuivi')}
                    </div>
                </Col>
                <Col sm="6">
                    {(values.idModaliteSuivi == "121581")/*Présentiel*/ &&
                        <Campus
                            values={values}
                            campus={campus}
                            handleChange={handleChange}
                            handleErreur={handleErreur} />
                    }
                </Col>
            </Row>
            <Row className="mb-5">
                <Col sm="6">
                    <div class="d-flex flex-column">
                        <label>Quelle filière vous intéresse ?*</label>
                        <div class="d-flex justify-content-between mt-3">
                            {getFiliere()}
                        </div>
                        {handleErreur("idFiliere")}
                    </div>
                </Col>
                <Col sm="6">
                    <Formation
                        values={values}
                        formations={filieres?.find(f => f.id == values.idFiliere)?.formations}
                        handleChange={handleChange}
                        handleErreur={handleErreur}
                    />
                </Col>
            </Row>
            <Row className="mb-1">
                <Col sm="6">
                    <div className="d-flex flex-column">
                        <label>Quel type de modalité envisagez-vous ?* </label>
                        {CodeTypeJourneeInformation == 1 || values.idFormation == 1400990 /*Bac+5 Dev*/ || values.idFormation == 521 /*Bac+5 Res*/ ? (
                            // Affiche la zone de texte si CodeTypeJourneeInformation est 1 ou s la formation choisie est Bac+5 Dev ou Bac+5 Res
                            <input
                                type="text"
                                value="Alternance"
                                readOnly
                                id="idTypeFormation"
                                class="opacity-50"
                            />
                        ) : (
                            // Sinon, affiche le select avec les options
                            <select
                                disabled={CodeTypeJourneeInformation == 1}
                                type="text"
                                value={values.idTypeFormation}
                                onChange={handleChange('idTypeFormation')}
                                id="idTypeFormation"
                            >
                                <option value="0" selected="selected"></option>
                                {getTypeFormation()}
                            </select>
                        )}
                        {handleErreur("idTypeFormation")}
                    </div>
                </Col>
                <Col sm="6">
                    <DateTest
                        values={values}
                        dates={dates}
                        handleChange={handleChange}
                        handleErreur={handleErreur}
                    />
                </Col>
            </Row>
            <div class="mb-5  d-flex justify-content-end mt-sm-0 mt-4">
                <button class="btn-outline-green-eni border-outline-green-eni fs-20 lh-15 p-3" onClick={Continue}>Suivant</button>
            </div>
            <span class="color-grey-light-eni fs-12">* Les champs précédés d'un astérisque sont obligatoires</span>
        </div>
    )
}

export default Journee